/**
 * IMPORTANT! Now code in uppercas!
 */
import { LanguageInfo } from './types';

export const languages: LanguageInfo[] = [
  {
    code: 'AA',
    i18nEn: 'Afar',
  },
  {
    code: 'AB',
    i18nEn: 'Abkhazian',
  },
  {
    code: 'AE',
    i18nEn: 'Avestan',
  },
  {
    code: 'AF',
    i18nEn: 'Afrikaans',
  },
  {
    code: 'AK',
    i18nEn: 'Akan',
  },
  {
    code: 'AM',
    i18nEn: 'Amharic',
  },
  {
    code: 'AN',
    i18nEn: 'Aragonese',
  },
  {
    code: 'AR',
    i18nEn: 'Arabic',
  },
  {
    code: 'AS',
    i18nEn: 'Assamese',
  },
  {
    code: 'AV',
    i18nEn: 'Avaric',
  },
  {
    code: 'AY',
    i18nEn: 'Aymara',
  },
  {
    code: 'AZ',
    i18nEn: 'Azerbaijani',
  },
  {
    code: 'BA',
    i18nEn: 'Bashkir',
  },
  {
    code: 'BE',
    i18nEn: 'Belarusian',
  },
  {
    code: 'BG',
    i18nEn: 'Bulgarian',
  },
  {
    code: 'BH',
    i18nEn: 'Bihari',
  },
  {
    code: 'BI',
    i18nEn: 'Bislama',
  },
  {
    code: 'BM',
    i18nEn: 'Bambara',
  },
  {
    code: 'BN',
    i18nEn: 'Bengali',
  },
  {
    code: 'BO',
    i18nEn: 'Tibetan',
  },
  {
    code: 'BR',
    i18nEn: 'Breton',
  },
  {
    code: 'BS',
    i18nEn: 'Bosnian',
  },
  {
    code: 'CA',
    i18nEn: 'Catalan',
  },
  {
    code: 'CE',
    i18nEn: 'Chechen',
  },
  {
    code: 'CH',
    i18nEn: 'Chamorro',
  },
  {
    code: 'CO',
    i18nEn: 'Corsican',
  },
  {
    code: 'CR',
    i18nEn: 'Cree',
  },
  {
    code: 'CS',
    i18nEn: 'Czech',
  },
  {
    code: 'CU',
    i18nEn: 'Old Church Slavonic',
  },
  {
    code: 'CV',
    i18nEn: 'Chuvash',
  },
  {
    code: 'CY',
    i18nEn: 'Welsh',
  },
  {
    code: 'DA',
    i18nEn: 'Danish',
  },
  {
    code: 'DE',
    i18nEn: 'German',
  },
  {
    code: 'DV',
    i18nEn: 'Divehi',
  },
  {
    code: 'DZ',
    i18nEn: 'Dzongkha',
  },
  {
    code: 'EE',
    i18nEn: 'Ewe',
  },
  {
    code: 'EL',
    i18nEn: 'Greek',
  },
  {
    code: 'EN',
    i18nEn: 'English',
  },
  {
    code: 'EO',
    i18nEn: 'Esperanto',
  },
  {
    code: 'ES',
    i18nEn: 'Spanish',
  },
  {
    code: 'ET',
    i18nEn: 'Estonian',
  },
  {
    code: 'EU',
    i18nEn: 'Basque',
  },
  {
    code: 'FA',
    i18nEn: 'Persian',
  },
  {
    code: 'FF',
    i18nEn: 'Fulah',
  },
  {
    code: 'FI',
    i18nEn: 'Finnish',
  },
  {
    code: 'FJ',
    i18nEn: 'Fijian',
  },
  {
    code: 'FO',
    i18nEn: 'Faroese',
  },
  {
    code: 'FR',
    i18nEn: 'French',
  },
  {
    code: 'FY',
    i18nEn: 'Western Frisian',
  },
  {
    code: 'GA',
    i18nEn: 'Irish',
  },
  {
    code: 'GD',
    i18nEn: 'Scottish Gaelic',
  },
  {
    code: 'GL',
    i18nEn: 'Galician',
  },
  {
    code: 'GN',
    i18nEn: 'Guarani',
  },
  {
    code: 'GU',
    i18nEn: 'Gujarati',
  },
  {
    code: 'GV',
    i18nEn: 'Manx',
  },
  {
    code: 'HA',
    i18nEn: 'Hausa',
  },
  {
    code: 'HE',
    i18nEn: 'Hebrew',
  },
  {
    code: 'HI',
    i18nEn: 'Hindi',
  },
  {
    code: 'HO',
    i18nEn: 'Hiri Motu',
  },
  {
    code: 'HR',
    i18nEn: 'Croatian',
  },
  {
    code: 'HT',
    i18nEn: 'Haitian',
  },
  {
    code: 'HU',
    i18nEn: 'Hungarian',
  },
  {
    code: 'HY',
    i18nEn: 'Armenian',
  },
  {
    code: 'HZ',
    i18nEn: 'Herero',
  },
  {
    code: 'IA',
    i18nEn: 'Interlingua',
  },
  {
    code: 'ID',
    i18nEn: 'Indonesian',
  },
  {
    code: 'IE',
    i18nEn: 'Interlingue',
  },
  {
    code: 'IG',
    i18nEn: 'Igbo',
  },
  {
    code: 'II',
    i18nEn: 'Sichuan Yi',
  },
  {
    code: 'IK',
    i18nEn: 'Inupiaq',
  },
  {
    code: 'IN',
    i18nEn: 'Bahasa Indonesia',
  },
  {
    code: 'IO',
    i18nEn: 'Ido',
  },
  {
    code: 'IS',
    i18nEn: 'Icelandic',
  },
  {
    code: 'IT',
    i18nEn: 'Italian',
  },
  {
    code: 'IU',
    i18nEn: 'Inuktitut',
  },
  {
    code: 'JA',
    i18nEn: 'Japanese',
  },
  {
    code: 'JV',
    i18nEn: 'Javanese',
  },
  {
    code: 'KA',
    i18nEn: 'Georgian',
  },
  {
    code: 'KG',
    i18nEn: 'Kongo',
  },
  {
    code: 'KI',
    i18nEn: 'Kikuyu',
  },
  {
    code: 'KJ',
    i18nEn: 'Kuanyama',
  },
  {
    code: 'KK',
    i18nEn: 'Kazakh',
  },
  {
    code: 'KL',
    i18nEn: 'Greenlandic',
  },
  {
    code: 'KM',
    i18nEn: 'Central Khmer',
  },
  {
    code: 'KN',
    i18nEn: 'Kannada',
  },
  {
    code: 'KO',
    i18nEn: 'Korean',
  },
  {
    code: 'KR',
    i18nEn: 'Kanuri',
  },
  {
    code: 'KS',
    i18nEn: 'Kashmiri',
  },
  {
    code: 'KU',
    i18nEn: 'Kurdish',
  },
  {
    code: 'KV',
    i18nEn: 'Komi',
  },
  {
    code: 'KW',
    i18nEn: 'Cornish',
  },
  {
    code: 'KY',
    i18nEn: 'Kirghiz',
  },
  {
    code: 'LA',
    i18nEn: 'Latin',
  },
  {
    code: 'LB',
    i18nEn: 'Luxembourgish',
  },
  {
    code: 'LG',
    i18nEn: 'Ganda',
  },
  {
    code: 'LI',
    i18nEn: 'Limburgan',
  },
  {
    code: 'LN',
    i18nEn: 'Lingala',
  },
  {
    code: 'LO',
    i18nEn: 'Lao',
  },
  {
    code: 'LT',
    i18nEn: 'Lithuanian',
  },
  {
    code: 'LU',
    i18nEn: 'Luba-Katanga',
  },
  {
    code: 'LV',
    i18nEn: 'Latvian',
  },
  {
    code: 'MG',
    i18nEn: 'Malagasy',
  },
  {
    code: 'MH',
    i18nEn: 'Marshallese',
  },
  {
    code: 'MI',
    i18nEn: 'Maori',
  },
  {
    code: 'MK',
    i18nEn: 'Macedonian',
  },
  {
    code: 'ML',
    i18nEn: 'Malayalam',
  },
  {
    code: 'MN',
    i18nEn: 'Mongolian',
  },
  {
    code: 'MR',
    i18nEn: 'Marathi',
  },
  {
    code: 'MS',
    i18nEn: 'Malay',
  },
  {
    code: 'MT',
    i18nEn: 'Maltese',
  },
  {
    code: 'MY',
    i18nEn: 'Burmese',
  },
  {
    code: 'NA',
    i18nEn: 'Nauru',
  },
  {
    code: 'NB',
    i18nEn: 'Norwegian Bokmål',
  },
  {
    code: 'ND',
    i18nEn: 'North Ndebele',
  },
  {
    code: 'NE',
    i18nEn: 'Nepali',
  },
  {
    code: 'NG',
    i18nEn: 'Ndonga',
  },
  {
    code: 'NL',
    i18nEn: 'Dutch',
  },
  {
    code: 'NN',
    i18nEn: 'Norwegian Nynorsk',
  },
  {
    code: 'NO',
    i18nEn: 'Norwegian',
  },
  {
    code: 'NR',
    i18nEn: 'South Ndebele',
  },
  {
    code: 'NV',
    i18nEn: 'Navajo',
  },
  {
    code: 'NY',
    i18nEn: 'Chichewa',
  },
  {
    code: 'OC',
    i18nEn: 'Occitan',
  },
  {
    code: 'OJ',
    i18nEn: 'Ojibwa',
  },
  {
    code: 'OM',
    i18nEn: 'Oromo',
  },
  {
    code: 'OR',
    i18nEn: 'Oriya',
  },
  {
    code: 'OS',
    i18nEn: 'Ossetian',
  },
  {
    code: 'PA',
    i18nEn: 'Panjabi',
  },
  {
    code: 'PI',
    i18nEn: 'Pali',
  },
  {
    code: 'PL',
    i18nEn: 'Polish',
  },
  {
    code: 'PS',
    i18nEn: 'Pashto',
  },
  {
    code: 'PT',
    i18nEn: 'Portuguese',
  },
  {
    code: 'QU',
    i18nEn: 'Quechua',
  },
  {
    code: 'RM',
    i18nEn: 'Romansh',
  },
  {
    code: 'RN',
    i18nEn: 'Rundi',
  },
  {
    code: 'RO',
    i18nEn: 'Romanian',
  },
  {
    code: 'RU',
    i18nEn: 'Russian',
  },
  {
    code: 'RW',
    i18nEn: 'Kinyarwanda',
  },
  {
    code: 'SA',
    i18nEn: 'Sanskrit',
  },
  {
    code: 'SC',
    i18nEn: 'Sardinian',
  },
  {
    code: 'SD',
    i18nEn: 'Sindhi',
  },
  {
    code: 'SE',
    i18nEn: 'Northern Sami',
  },
  {
    code: 'SG',
    i18nEn: 'Sango',
  },
  {
    code: 'SI',
    i18nEn: 'Sinhala',
  },
  {
    code: 'SK',
    i18nEn: 'Slovak',
  },
  {
    code: 'SL',
    i18nEn: 'Slovenian',
  },
  {
    code: 'SM',
    i18nEn: 'Samoan',
  },
  {
    code: 'SN',
    i18nEn: 'Shona',
  },
  {
    code: 'SO',
    i18nEn: 'Somali',
  },
  {
    code: 'SQ',
    i18nEn: 'Albanian',
  },
  {
    code: 'SR',
    i18nEn: 'Serbian',
  },
  {
    code: 'SS',
    i18nEn: 'Swati',
  },
  {
    code: 'ST',
    i18nEn: 'Southern Sotho',
  },
  {
    code: 'SU',
    i18nEn: 'Sundanese',
  },
  {
    code: 'SV',
    i18nEn: 'Swedish',
  },
  {
    code: 'SW',
    i18nEn: 'Swahili',
  },
  {
    code: 'TA',
    i18nEn: 'Tamil',
  },
  {
    code: 'TE',
    i18nEn: 'Telugu',
  },
  {
    code: 'TG',
    i18nEn: 'Tajik',
  },
  {
    code: 'TH',
    i18nEn: 'Thai',
  },
  {
    code: 'TI',
    i18nEn: 'Tigrinya',
  },
  {
    code: 'TK',
    i18nEn: 'Turkmen',
  },
  {
    code: 'TL',
    i18nEn: 'Tagalog',
  },
  {
    code: 'TN',
    i18nEn: 'Tswana',
  },
  {
    code: 'TO',
    i18nEn: 'Tonga',
  },
  {
    code: 'TR',
    i18nEn: 'Turkish',
  },
  {
    code: 'TS',
    i18nEn: 'Tsonga',
  },
  {
    code: 'TT',
    i18nEn: 'Tatar',
  },
  {
    code: 'TW',
    i18nEn: 'Twi',
  },
  {
    code: 'TY',
    i18nEn: 'Tahitian',
  },
  {
    code: 'UG',
    i18nEn: 'Uighur',
  },
  {
    code: 'UK',
    i18nEn: 'Ukrainian',
  },
  {
    code: 'UR',
    i18nEn: 'Urdu',
  },
  {
    code: 'UZ',
    i18nEn: 'Uzbek',
  },
  {
    code: 'VE',
    i18nEn: 'Venda',
  },
  {
    code: 'VI',
    i18nEn: 'Vietnamese',
  },
  {
    code: 'VO',
    i18nEn: 'Volapük',
  },
  {
    code: 'WA',
    i18nEn: 'Walloon',
  },
  {
    code: 'WO',
    i18nEn: 'Wolof',
  },
  {
    code: 'XH',
    i18nEn: 'Xhosa',
  },
  {
    code: 'YI',
    i18nEn: 'Yiddish',
  },
  {
    code: 'YO',
    i18nEn: 'Yoruba',
  },
  {
    code: 'ZA',
    i18nEn: 'Zhuang',
  },
  {
    code: 'ZH',
    i18nEn: 'Chinese',
  },
  {
    code: 'ZU',
    i18nEn: 'Zulu',
  },
];
